/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable dot-notation */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import global from 'global/window';
export function hasCreateImageBitmap() {
    if (global['createImageBitmap'] === undefined) {
        return false;
    }
    return true;
}
export function hasBroadcastChannel() {
    if (global['BroadcastChannel'] === undefined) {
        return false;
    }
    return true;
}
export function hasLocalStorage() {
    try {
        if (global['localStorage'] === undefined) {
            return false;
        }
    }
    catch (err) {
        /* if it throws localStorage is probably disabled for security reasons */
        return false;
    }
    return true;
}
// Check if createImageBitmap supports resizing (see https://caniuse.com/createimagebitmap)
// At the time of writing this fails on Firefox <= 98
let $hasCreateImageResizeBug;
export function hasCreateImageResizeBug() {
    return __awaiter(this, void 0, void 0, function* () {
        if (!hasCreateImageBitmap()) {
            throw new Error('Missing createImageBitamp API');
        }
        if (typeof $hasCreateImageResizeBug === 'boolean') {
            return $hasCreateImageResizeBug;
        }
        // PNG white rectangle 20x20
        // > convert xc:white -size 20x20 -background white -colors 2 -depth 4 o.png
        // > openssl base64 -in o.png -out o.base64
        const inSize = { width: 20, height: 20 };
        const data = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQAAAAA3bvkkAAAABGdBTUEAALGPC/xhBQAAAAJiS0dEAAHdihOkAAAAB3RJTUUH5gIFFDoT++9lZgAAAApJREFUCNdjaAAAAIIAgd1DavQAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMDItMDVUMjA6NTg6MTkrMDA6MDD2/RnDAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTAyLTA1VDIwOjU4OjE5KzAwOjAwh6ChfwAAAABJRU5ErkJggg==';
        try {
            const resizeWidth = Math.round(inSize.width * 0.5);
            const resizeHeight = Math.round(inSize.height * 0.5);
            const png = yield fetch(data).then(res => res.blob());
            const bitmap = yield createImageBitmap(png, {
                resizeWidth,
                resizeHeight,
                resizeQuality: 'pixelated',
            });
            const imageResized = bitmap.width === resizeWidth && bitmap.height === resizeHeight;
            bitmap.close();
            $hasCreateImageResizeBug = imageResized === false;
            if ($hasCreateImageResizeBug) {
                console.warn('createImageBitmap has a resize bug.');
            }
            return $hasCreateImageResizeBug;
        }
        catch (err) {
            console.error(err);
            return true;
        }
    });
}
export function hasOffscreenCanvas() {
    // eslint-disable-next-line dot-notation
    if (global['OffscreenCanvas'] === undefined) {
        return false;
    }
    // check for offline-canvas 2d support (FF experimental doesn't support 2d context)
    // eslint-disable-next-line dot-notation
    if (global['OffscreenCanvasRenderingContext2D'] === undefined) {
        return false;
    }
    return true;
}
export function hasClipboard() {
    const { clipboard } = navigator;
    return (clipboard &&
        'write' in clipboard &&
        typeof clipboard.write === 'function');
}
export function hasIndexedDB() {
    return __awaiter(this, void 0, void 0, function* () {
        const DB_NAME = 'annotely_indexeddb_test';
        const DB_VERSION = 1;
        try {
            const result = yield new Promise(resolve => {
                const request = indexedDB.open(DB_NAME, DB_VERSION);
                request.onerror = () => {
                    const { error } = request;
                    const message = error === null || error === void 0 ? void 0 : error.message;
                    resolve({ status: 'error', message });
                };
                request.onsuccess = () => {
                    var _a;
                    (_a = request.result) === null || _a === void 0 ? void 0 : _a.close();
                    resolve({ status: 'success' });
                };
            });
            if (result.status === 'error') {
                throw new Error(`Failed to open IndexedDB; message: ${result.message}`);
            }
        }
        catch (error) {
            console.log(error);
            return false;
        }
        return true;
    });
}
export const hasCrypto = () => {
    if (global['crypto'] === undefined) {
        return false;
    }
    if (crypto['subtle'] === undefined) {
        return false;
    }
    return true;
};
export const hasTouchEvent = () => {
    // eslint-disable-next-line dot-notation
    const TouchEventCls = window['TouchEvent'];
    return typeof TouchEventCls !== 'undefined';
};
export const hasPointerEvent = () => {
    // eslint-disable-next-line dot-notation
    const TouchEventCls = window['PointerEvent'];
    return typeof TouchEventCls !== 'undefined';
};
export const hasMediaDevices = () => {
    if ('mediaDevices' in navigator) {
        if (typeof navigator.mediaDevices.getDisplayMedia === 'function') {
            return true;
        }
    }
    return false;
};
